import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LocaleType } from '../locales';

interface SEOProps {
  locale: LocaleType;
}

const SEO: React.FC<SEOProps> = ({ locale }) => {
  const location = useLocation();

  useEffect(() => {
    // 根据语言设置不同的标题和描述
    const seoData = {
      en: {
        title: 'Online Ruler - Digital Measuring Tool | Free Centimeter & Inch Ruler',
        description: 'Free online ruler with centimeter and inch measurements. Accurate digital measuring tool for screen calibration. Perfect for designers, developers, and anyone needing precise measurements.',
        keywords: 'online ruler, digital ruler, screen ruler, centimeter ruler, inch ruler, measuring tool, calibration, free ruler, web ruler'
      },
      zh: {
        title: '在线尺子 - 数字测量工具 | 免费厘米英寸尺子',
        description: '免费在线尺子，支持厘米和英寸测量。精确的数字测量工具，用于屏幕校准。适合设计师、开发者和需要精确测量的用户。',
        keywords: '在线尺子, 数字尺子, 屏幕尺子, 厘米尺子, 英寸尺子, 测量工具, 校准, 免费尺子, 网页尺子'
      },
      nl: {
        title: 'Online Liniaal - Digitaal Meetinstrument | Gratis Centimeter & Inch Liniaal',
        description: 'Gratis online liniaal met centimeter en inch metingen. Nauwkeurig digitaal meetinstrument voor schermkalibratie. Perfect voor ontwerpers, ontwikkelaars en iedereen die nauwkeurige metingen nodig heeft.',
        keywords: 'online liniaal, digitale liniaal, schermliniaal, centimeter liniaal, inch liniaal, meetinstrument, kalibratie, gratis liniaal, web liniaal'
      }
    };

    const currentSEO = seoData[locale];

    // 更新页面标题
    document.title = currentSEO.title;

    // 更新meta描述
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', currentSEO.description);
    }

    // 更新meta关键词
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', currentSEO.keywords);
    }

    // 更新Open Graph标签
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', currentSEO.title);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', currentSEO.description);
    }

    // 更新Twitter标签
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', currentSEO.title);
    }

    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', currentSEO.description);
    }

    // 更新HTML lang属性
    const htmlElement = document.documentElement;
    const langMap = { en: 'en', zh: 'zh-CN', nl: 'nl' };
    htmlElement.lang = langMap[locale];

    // 更新canonical URL
    const canonicalUrl = `https://ruler-online.vercel.app${location.pathname}`;
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link') as HTMLLinkElement;
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

  }, [locale, location.pathname]);

  return null; // 这个组件不渲染任何内容
};

export default SEO; 